

import { useEffect, useRef, useState } from 'react';

import './EpisodeInformation.scss';
import { useReaderSetting } from '../../../../../Recoil/Novel/ReaderSetting';

const EpisodeInformation = ({title, }:{title: TitleType & TitleAugmentedData}) => {

    const {setting} = useReaderSetting();

    const [opacity, setOpacity] = useState<number>(0);
    const targetRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        const scrollHandler = () => {
            const target = document.querySelector(".EpisodeInformationArea");

            const top = target?.getBoundingClientRect().top || 0;
            const bottom = target?.getBoundingClientRect().bottom || Infinity;

            setOpacity(Math.min(1, -top / (bottom - top)));
        };
        window.addEventListener("scroll", scrollHandler);

        return () => {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);

    return (<div className={`EpisodeInformationArea ${setting.theme}`} ref={targetRef} >
        <div className={"EpInformationInner"} >
            <div className={`ThumbnailBackground ${setting.theme}`}  >
                <img src={"https://static.novela.today/image/BlossomsInAdversityBlur.png"} alt={`${title?.title}-image-blur`} className={"ThumbImageBlur"} />
                <div className={`ShortFilter`} />
                <div className={`NovelThumbnail`}>
                    <img src={title?.thumbnail} alt={`${title?.title}-image`} className={"ThumbImage"} />
                </div>
                <div className={"NovelInfos"}>
                    <div className={"NovelTitle"} >
                        {title?.title}
                    </div>
                    <div className={"NovelInfo"} >
                        <span >
                            {[
                                ...title.tags.split(","),
                                title.is_finished ? "완결" : "연재중"
                            ].filter((item, index, array) => array.indexOf(item) === index)
                             .join(" · ")}
                        </span>
                        <span className={"Divider"}>{"|"}</span>
                        <span>{title.author}</span>
                    </div>
                </div>
                <div className={"NovelDescription"} >
                    {title?.description}
                </div>
            </div>
        </div>
        <div className={`EpisodeInformationCover`} style={{opacity}} ></div>
    </div>)
}

export default EpisodeInformation;